import React from 'react';
import disabled from '../../../images/disabled.png';
import disabled_gray from '../../../images/disabled_gray.png';
import disabled_pink from '../../../images/disabled_pink.png';
import { Modal, Icon } from 'antd';

class DisabledPopup extends React.Component {
  render() {
    const { color, t } = this.props;
    const styles = {
      title: {
        marginBottom: 10,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        textAlign: 'center',
        marginTop: 20
      },
      button: {
        margin: '0 auto',
        backgroundColor: 'white',
        color: color,
        border: `1px solid ${color}`,
        borderRadius: '20px',
        width: '48%',
        textAlign: 'center',
        marginTop: 20,
        cursor: 'pointer',
        padding: 5,
        marginBottom: 20,
        fontFamily: 'Arial Rounded MT Bold'
      },
      submit: {
        margin: '0 auto',
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: '48%',
        textAlign: 'center',
        marginTop: 20,
        cursor: 'pointer',
        padding: 5,
        marginBottom: 20,
        fontFamily: 'Arial Rounded MT Bold'
      },
      icon: {
        fontSize: 124,
        color: color,
        margin: '0 auto',
        display: 'block'
      }
    };

    let image;
    if (color == '#F190AC') {
      image = disabled_pink;
    } else if (color == '#7c868d') {
      image = disabled_gray;
    } else {
      image = disabled;
    }

    return (
      <Modal
        footer={false}
        visible={this.props.open}
        onCancel={this.props.close}
        width={450}>
        <Icon style={styles.icon} type="exclamation-circle" />
        <h3 style={styles.title}>Are you sure you want to submit?</h3>
        <div
          style={{
            display: 'inline-flex',
            justifyContent: 'space-between',
            width: '100%'
          }}>
          <div onClick={() => this.props.close()} style={styles.button}>
            Keep Editing
          </div>
          <div onClick={() => this.props.submit()} style={styles.submit}>
            Submit
          </div>
        </div>
      </Modal>
    );
  }
}

export default DisabledPopup;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/confirmPopup.js